export default __webpack_public_path__ + "static/media/circleForegroundLeftLight.f81c8179.svg";